import { render } from "./FlowPanelContentBlock.vue?vue&type=template&id=b064875c&scoped=true&ts=true"
import script from "./FlowPanelContentBlock.vue?vue&type=script&lang=ts"
export * from "./FlowPanelContentBlock.vue?vue&type=script&lang=ts"

import "./FlowPanelContentBlock.vue?vue&type=style&index=0&id=b064875c&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b064875c"]])

export default __exports__